module.exports = __webpack_public_path__ + "img/background-customer.0a0ae70a.svg";